import { FIELD_INPUT } from "../../../tools/actions/ActionHelper";
import AbstractField from "./AbstractField";

export default class AreaField extends AbstractField {
    isInputField = true;

    populate(element) {
        this.reset();
        this.inputElement.value(element.notes ?? '');
    }

    make() {
        this.field = this.p.createDiv();
        this.labelDiv = this.p.createElement('h3', 'Notes')
            .parent(this.field)
            .class('input-label');
        this.parentElement ? this.field.parent(this.parentElement) : null;
        this.applyClasses();
        this.applyStyles();

        this.inputElement = this.p.createElement('textarea', '')
            .parent(this.field)
            .class('input-text')
            .input(() => this.action?.update())
            .id('notes');
        this.setFocusAndBlurActions();

        this.initialized = true;
        return this;
    }

    value(value) {
        if (value === undefined) {
            return this.inputElement.value();
        }
        this.inputElement.value(value);
        return this;
    }

    getValue() {
        return this.value();
    }

    focus() {
        this.inputElement.elt.focus();
    }

    setFocusAndBlurActions() {
        this.inputElement.elt.onfocus = () => {
            this.enableHotKeys = false;
            this.action = this.actions.new(
                FIELD_INPUT,
                this.getTab('info').currentElement,
                this,
                (element, value) => element.notes = value
            );
            this.getTab('info').activeInput = this.inputElement;
        };
        this.inputElement.elt.onblur = () => {
            this.enableHotKeys = true;
            this.action?.finish();
            let activeInput = this.getTab('info').activeInput;
            this.getTab('info').activeInput = activeInput == this.inputElement
                ? null
                : activeInput;
        };
    }

    reset() {
        this.inputElement.value('');
    }
}
